export const routes = [
  {
    path: '/v-mobile-platform',
    name: 'Mobile platform',
    component: () => import(/* webpackChunkName: "mobile_platform" */ '../views/mobile/platform')
  },
  {
    path: '/v-stampe',
    name: 'Stampe',
    component: () => import(/* webpackChunkName: "stampe" */ '../views/stampe')
  },
  {
    path: '/pdf',
    name: 'Pdf',
    component: () => import(/* webpackChunkName: "pdf" */ '../views/pdfViewer/viewer.vue'),
    props: route => ({ source: route.params.source })
  },
  {
    path: '/pdf-e',
    name: 'Pdf-e',
    props: route => ({ source: route.params.source }),
    meta: { external: true /* ,  newWindow: true */}
  },      
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login')
  },
  {
    path: '/token',
    name: 'Token',
    component: () => import(/* webpackChunkName: "token" */ '../views/licenza/tokenScaduto.vue')
  },
  {
    path: '/licenza',
    name: 'Licenza',
    component: () => import(/* webpackChunkName: "licenza" */ '../views/licenza/licenzaScaduta.vue')
  }
]
